@if (active) {
  <div class="forlab-page-loader" role="status" aria-live="polite" aria-label="Loading page">
    <mat-progress-spinner mode="indeterminate" diameter="52"></mat-progress-spinner>
    <span class="forlab-page-loader__text">Loading</span>
  </div>
}
